import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { goToPage, resetState } from '../DisconnectServiceSlice'
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import ServicesList from '../ServicesList/ServicesList';
import { Container } from 'reactstrap';
import ChooseReasonOfDisconnect from '../ChooseReasonOfDisconnect/ChooseReasonOfDisconnect'
import MobileGetterSection from '../mobileGetterSection/mobileGetterSection'
import ConfirmDisconnectPage from '../ConfirmDisconnectPage/ConfirmDisconnectPage'
import DisconnectingServiceHeader from '../DisconnectingServiceHeader/DisconnectingServiceHeader'
import IsSuccessfullCallbackPage from '../IsSuccessfullCallbackPage/IsSuccessfullCallbackPage'
import DisconnectPage from '../DisconnectPage/DisconnectPage'
import UpdateCellularProgramSuccessPage from '../DisconnectPage/DisconnectCellularPage/UpdateCellularProgramResultPage/UpdateCellularProgramSuccessPage'
import ScheduleDisconnectDatePage from '../DisconnectPage/DisconnectCellularPage/FinalDisconnectSteps/ScheduleDisconnectDatePage'
import SummarizeDisconnectPage from '../DisconnectPage/DisconnectCellularPage/FinalDisconnectSteps/SummarizeDisconnectPage'
import SuccessfulDisconnect from '../DisconnectPage/DisconnectCellularPage/FinalDisconnectSteps/SuccessfulDisconnect'
import DisconnectProductsPage from '../DisconnectPage/DisconnectCommonParts/DisconnectProductsPage'
import DeliveryProducts from '../DisconnectPage/DisconnectCommonParts/DeliveryProductsPage'
import SummarizePickUpDisconnect from '../DisconnectPage/DisconnectCommonParts/SummarizePickUpDisconnect'
import SummarizeSelfDisconnect from '../DisconnectPage/DisconnectCommonParts/SummarizeSelfDisconnect'
import SummaryAfterFailedDelivery from '../DisconnectPage/DisconnectCommonParts/SummaryAfterFailedDelivery'
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../../utilities/hooks/useClearStateResetFlag';


function DisconnectServiceMain({ context, iContent, stepInProcess, goToPage, stepParams, UserInfo, resetState, finalDisconnectResponse, isLoading }) {

    const cost = iContent.deliveryCost.value != null ? iContent.deliveryCost.value : '';
    const commercialPic = iContent.programDetailsPhoto.value != null ? iContent.programDetailsPhoto.value.url : '';
    const kosherCommercialPic = iContent.kosherProgramDetailsPhoto.value != null ? iContent.kosherProgramDetailsPhoto.value.url : '';
    const commercialPdf = iContent.programPDF.value != null ? iContent.programPDF.value.url : '';
    const kosherCommercialPdf = iContent.kosherProgramPDF.value != null ? iContent.kosherProgramPDF.value.url : '';
    const equipmentList = iContent.equipmentForProductArea.expandedValue
    const callBackCode = iContent.callBackCode.value != null ? iContent.callBackCode.value : '';
    const programCode = iContent.programCode.value != null ? iContent.programCode.value : '';
    const kosherProgramCode = iContent.kosherProgramCode.value != null ? iContent.kosherProgramCode.value : '';
    const redirectTo = iContent.urlTo.value != null ? iContent.urlTo.value : '';
    const displayDiscountPackage = iContent.showDisccountPackage.value;
    const displayKosherDiscountPackage = iContent.showDisccountKosherPackage.value;
    
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
          if(finalDisconnectResponse != '') {
            resetState();
          }
        }
    }, []);

    useEffect(() => {
      if (typeof window.scrollTo === "function") { 
        window.scrollTo(0, 0);
      } 
      gaEvent(gaParams.ENTER_DISCONNECT_MAIN_PAGE.category, gaParams.ENTER_DISCONNECT_MAIN_PAGE.eventType, gaParams.ENTER_DISCONNECT_MAIN_PAGE.eventParams);
    }, []);

    useEffect(() => {
      return () => {
        resetState();
      }
    }, [])

    function redirectToCallBackAndReportGA() {
      ReportGA();
      goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: true } })
    }

    function ReportGA() {
      gaEvent(gaParams.DISCONNECT_CLICK_ON_GET_BACK_TO_ME.category, gaParams.DISCONNECT_CLICK_ON_GET_BACK_TO_ME.eventType, gaParams.DISCONNECT_CLICK_ON_GET_BACK_TO_ME.eventParams);
    }
    

    function renderStep() {
      switch (stepInProcess) {
        case 'MAIN_PAGE': return (
          <Container className="disconnectServices-container">
            {isLoading === false ?
            <div className="subContainer">
                <h2 className="headers-root">ניתוק משירות</h2>
                <h5 className="headers">רגע לפני, אם יש משהו שנוכל לעשות, נשמח לשמוע</h5>
                <div className="btn-container">
                    <BtnSubmit text="כן, אשמח שתחזרו אליי" onclick={() => redirectToCallBackAndReportGA()}/>
                </div>
            </div> : null }
            <ServicesList /> 
          </Container>
        );

        case 'CHOOSE_DISCONNECT_REASON': return (
          <ChooseReasonOfDisconnect />
        );
        case 'GET_BACK_TO_YOU_BY_NUMBER': return (
          <MobileGetterSection callBackCode={callBackCode}/>
        );
        case 'CONFIRM_DISCONNECT_PAGE': return (
          <ConfirmDisconnectPage />
        );
        case 'REPLAY_RESULT_PAGE': return (
          <IsSuccessfullCallbackPage redirectTo={redirectTo} context={context}/>
        );
        case 'DISCONNECT_PAGE': return (
          <DisconnectPage cost={cost} commercialPic={commercialPic} commercialPdf={commercialPdf} kosherCommercialPic={kosherCommercialPic} programCode={programCode} kosherProgramCode={kosherProgramCode} displayDiscountPackage={displayDiscountPackage} displayKosherDiscountPackage={displayKosherDiscountPackage}/>
        )
        case 'SUCCESS_UPDATE_CELLULAR_PROGRAM': return (
          <UpdateCellularProgramSuccessPage redirectTo={redirectTo} context={context}/>
        )
        case 'SCHEDULE_DISCONNECT_DATE_PAGE': return (
          <ScheduleDisconnectDatePage />
        )
        case 'SUMMARIZE_DISCONNECT_CELLULAR_PAGE': return (
          <SummarizeDisconnectPage />
        )
        case 'SUCCESS_MOBILE_DISCONNECT': return (
          <SuccessfulDisconnect redirectTo={redirectTo} context={context}/>
        )
        case 'DISCONNECT_PRODUCTS_PAGE': return (
          <DisconnectProductsPage equipmentList={equipmentList}/>
        )
        case 'DELIVERY_PRODUCTS_PAGE': return (
          <DeliveryProducts cost={cost}/>
        )
        case 'PICK_UP_PRODUCT_RETURN_PAGE': return (
          <SummarizePickUpDisconnect equipmentList={equipmentList} cost={cost} redirectTo={redirectTo} context={context}/>
        )
        case 'FAILED_DELIVERY_PICK_UP': return (
          <SummaryAfterFailedDelivery redirectTo={redirectTo} context={context}/>
        )
        case 'SELF_PRODUCT_RETURN_PAGE': return (
          <SummarizeSelfDisconnect equipmentList={equipmentList} redirectTo={redirectTo} context={context}/>
        )
      }
    }

    useClearStateResetFlag()

    return (
      <div>
          {stepParams.hideHeader == false ? <DisconnectingServiceHeader /> : null }
          {renderStep()}
      </div>
    )   
}

const mapStateToProps = (state) => ({
    stepInProcess: state.disconnectServicesBlock.stepInProcess,
    stepParams: state.disconnectServicesBlock.stepParams,
    UserInfo: state.authentication.loginData.userDetails,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    callBackAlreadyExist: state.disconnectServicesBlock.callBackAlreadyExist,
    isLoading: state.disconnectServicesBlock.isLoading
  });
  
  const mapDispatchToProps = {
    goToPage,
    resetState
};

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectServiceMain);